angular.module('impactx.deliverycomplaint').controller('DeliveryComplaintCtrl', DeliveryComplaintCtrl);
DeliveryComplaintCtrl.$inject = [
    '$scope',
    '$routeParams',
    'dataGen',
    'ToastService',
    'BackService',
    '$mdDialog',
    '$redirect',
    'OutsourcedCommentSaveService',
    '$q',
    'ToolbarService'
];

function DeliveryComplaintCtrl($scope, $routeParams, dataGen, ToastService, BackService, $mdDialog, $redirect, OutsourcedCommentSaveService, $q, ToolbarService) {
    $scope.selectedComplaintItems = [];
    $scope.showItemComments = false;

    var ctrl = this;
    var id = $routeParams.id;
    var dnhid = $routeParams.dnhid || 0;
    var pohid = $routeParams.pohid || 0;
    var doCheck = $routeParams.doCheck || false;
    var acceptedPartialDelivery = $routeParams.acceptPartialDelivery || false;
    var acceptedOvershipment = $routeParams.acceptedOvershipment || false;
    var needsAllItems = $routeParams.needsAllItems || false;

    ctrl.hidePopup = function () {
        return dnhid > 0 || id > 0;
    };

    ctrl.toggleComments = function () {
        $scope.showItemComments = !$scope.showItemComments;
    };

    var getData = function (dnhId) {
        var temp = {};
        var params = {
            id: id,
            dnhId: dnhId,
            doCheck: doCheck,
            acceptedPartialDelivery: acceptedPartialDelivery,
            acceptedOvershipment: acceptedOvershipment,
            needsAllItems: needsAllItems
        };
        const lastParams = $redirect.getLastParameters();
        if (lastParams && lastParams.poiIds) {
            params.preselectedPOIs = lastParams.poiIds;
        }
        if (lastParams && lastParams.dniIds) {
            params.preselectedDNIs = lastParams.dniIds;
        }
        dataGen.getData(temp, params, '/deliverycomplaint/view').then(function () {
            $scope.data = temp.data;
            $scope.trns = temp.trns;
            defineButtons();
        })
    };

    $scope.$watch(function () {
        return $scope.data && $scope.data.deliveryNote ? $scope.data.deliveryNote.selected : null;
    }, function (newVal, oldVal) {
        if (newVal && newVal.id && (oldVal && oldVal.id !== newVal.id)) {
            handleDeliveryNote(newVal);
        }
    });

    var handleDeliveryNote = function (selected) {
        if (selected) {
            getData(selected.id);
        }
        else {
            getData(0);
        }
    };

    var adjustPositions = function () {
        var items = $scope.data.items;
        for (var i = 0; i < items.length; i++) {
            items[i].position = i + 1;
        }
    };

    // this is very ugly but i don't want to change the PriceProperty - DTO
    var repairNewTotalNetPrice = function () {
        var items = $scope.data.items;
        angular.forEach(items, function (item) {
            if (item.newPrice && !isUndefined(item.newPrice.totalNetValue)) {
                var tmp = item.newPrice.totalNetValue.value;
                item.newPrice.totalNetValue = tmp || 0;
            }
            if (item.marketplacePrice && !isUndefined(item.marketplacePrice.totalNetValue)) {
                var tmp = item.marketplacePrice.totalNetValue.value;
                item.marketplacePrice.totalNetValue = tmp || 0;
            }
        });
    };

    ctrl.extractCommentList = function () {
        var extractedCommentList = [];
        for (var i = 0; i < $scope.data.items.length; i++) {
            extractedCommentList.push(OutsourcedCommentSaveService.extractComments($scope.data.items[i]));
        }
        return extractedCommentList;
    };

    ctrl.postSave = function () {
        if (dnhid > 0) {
            $redirect.redirectTo(null, '/deliverynotedetail/' + dnhid);
        }
        else {
            BackService.back();
        }
        ToastService.openStandardToast($scope.trns.saveSuccess);

    };

    ctrl.save = function () {
        var extractedCommentList = ctrl.extractCommentList();
        repairNewTotalNetPrice();
        delete $scope.data.timeline;
        var dataObj = {
            data: $scope.data
        };
        var temp = {};
        return dataGen.postAsForm(temp, dataObj, '/deliverycomplaint/save').then(function (commentData) {
            if (commentData && commentData.data) {
                ctrl.saveCommentsChain(extractedCommentList, 0, commentData.data.tokenList).then(ctrl.postSave, ctrl.postSave);
            }
            else {
                ctrl.postSave();
            }
        }, function () {
            ctrl.restoreComments(extractedCommentList);
        });
    };

    ctrl.postSaveAndClose = function (data) {
        dataGen.postAsForm({}, {cphIds: data.data.cphIds}, '/deliverycomplaint/postprocessing').then(function () {
            if (data.data && data.data.rehId) {
                $redirect.redirectTo(null, '/retoure/' + data.data.rehId);
            }
            else {
                $redirect.redirectTo(null, '/purchaseorderlist');
            }
            ToastService.openStandardToast($scope.trns.saveSuccess);
        });
    };

    ctrl.saveAndCloseDialog = function (event) {
        if ($scope.data.allowAskSendToSupplier) {
            return $mdDialog.show({
                templateUrl: 'modules/deliverycomplaint/templates/asksendtosupplierdialog.tmpl.html',
                controller: "ComplaintAskSendToSupplierDialogCtrl",
                controllerAs: 'complaintAskSendToSupplierDialogCtrl',
                targetEvent: event,
                clickOutsideToClose: false,
                parent: angular.element(document.body),
                locals: {
                    trns: $scope.trns,
                    items: JSON.parse(JSON.stringify($scope.data.items))
                }
            }).then(function (result) {
                if (result) {
                    $scope.data.items = result;
                    return ctrl.saveAndClose();
                }
            });
        } else {
            return ctrl.saveAndClose();
        }
    };

    ctrl.saveAndClose = function () {
        var extractedCommentList = ctrl.extractCommentList();
        repairNewTotalNetPrice();
        delete $scope.data.timeline;
        var dataObj = {
            data: $scope.data
        };
        var temp = {};
        return dataGen.postAsForm(temp, dataObj, '/deliverycomplaint/saveandclose').then(function (data) {
            if (data && data.data) {
                ctrl.saveCommentsChain(extractedCommentList, 0, data.data.commentData.tokenList).then(function () {
                    ctrl.postSaveAndClose(data);
                }, function (data) {
                    ctrl.postSaveAndClose(data);
                });
            }
            else {
                ctrl.postSaveAndClose(data);
            }
        }, function () {
            ctrl.restoreComments(extractedCommentList);
        });
    };

    ctrl.restoreComments = function (extractedCommentList) {
        for (var i = 0; i < $scope.data.items.length; i++) {
            OutsourcedCommentSaveService.restoreComments($scope.data.items[i], extractedCommentList[i]);
        }
    };

    ctrl.saveCommentsChain = function (extractedCommentList, index, tokenList) {
        if (index < extractedCommentList.length && tokenList) {
            return OutsourcedCommentSaveService.saveComments(ctrl.findCorrectToken(tokenList, index + 1), extractedCommentList[index]).then(function () {
                index++;
                return ctrl.saveCommentsChain(extractedCommentList, index, tokenList);
            });
        }
        else {
            return $q.when();
        }
    };

    ctrl.findCorrectToken = function (tokenList, position) {
        for (var i = 0; i < tokenList.length; i++) {
            if (tokenList[i].position === position) {
                return tokenList[i];
            }
        }
        return undefined;
    };

    ctrl.deleteItem = function (item) {
        var indexAll = $scope.data.items.indexOf(item);
        var indexSelected = $scope.selectedComplaintItems.indexOf(item);
        if (indexAll > -1) {
            $scope.data.items.splice(indexAll, 1);
        }
        if (indexSelected > -1) {
            $scope.selectedComplaintItems.splice(indexSelected, 1);
        }
        adjustPositions();
    };

    ctrl.addItem = function (event) {
        $mdDialog.show({
            templateUrl: 'modules/deliverycomplaint/templates/addcomplaintitemdialog.tmpl.html',
            targetEvent: event,
            clickOutsideToClose: false,
            controller: "ComplaintItemDialogCtrl",
            controllerAs: 'complaintItemDialogCtrl',
            hasBackdrop: true,
            disableParentScroll: true,
            locals: {
                cphId: $scope.data.id,
                dnhId: $scope.data.deliveryNote.selected.id
            }
        }).then(function (results) { // result is a DeliveryComplaintItemDTO
            if (results) {
                angular.forEach(results, function (result) {
                    delete result.selected; // this is not nice, but in the dialog we need to keep track of selected items
                    $scope.data.items.push(result);
                });
                adjustPositions();
            }
        });

    };

    ctrl.sendMessage = function () {
        var params = {
            id: $scope.data.id
        };
        return dataGen.getData({}, params, "/deliverycomplaint/message").then(function () {
            ToastService.openStandardToast($scope.trns.messageSuccess);
        });
    };

    ctrl.listNotes = function (searchText) {
        let dataObject = {
            searchText: searchText,
            pohId: pohid
        };
        return dataGen.getData({}, dataObject, "/deliverycomplaint/input/deliverynote").then(function (data) {
            return data.data.entries
        })

    };

    ctrl.delete = function () {
        var params = {
            id: $scope.data.id
        };
        return dataGen.postAsForm({}, params, "/deliverycomplaint/delete").then(function () {
            ToastService.openStandardToast($scope.trns.deleteSuccess);
            BackService.back();
        });
    };

    ctrl.cancelConditions = function () {
        var params = {
            cphId: $scope.data.id
        };
        return dataGen.postAsForm({}, params, "/deliverycomplaint/simple/cancelconditions").then(function () {
            ToastService.openStandardToast($scope.trns.cancelSuccess);
            BackService.back();
        });
    };

    ctrl.cancelMasterConditions = function () {
        var params = {
            cphId: $scope.data.id
        };
        return dataGen.postAsForm({}, params, "/deliverycomplaint/simple/cancelmasterconditions").then(function () {

            ToastService.openStandardToast($scope.trns.cancelMasterSuccess);
            BackService.back();
        });
    };

    if (id > 0) {
        getData(0);
    }
    else {
        getData(dnhid);
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: canSave,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.saveAndClose,
                action: ctrl.saveAndCloseDialog,
                type: 'validation',
                condition: canSaveAndClose,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.delete,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.addItem,
                action: ctrl.addItem,
                type: 'dialogaction',
                condition: canAddItem
            },
            {
                label: $scope.trns.comments,
                action: ctrl.toggleComments,
                type: 'dialogaction',
                condition: canToggleComments
            },
            {
                label: $scope.trns.sendMessage,
                action: ctrl.sendMessage,
                type: 'dialogaction',
                condition: canSendMessage
            },
            {
                label: $scope.trns.retoure,
                linkFunction: getRetoureLink,
                type: 'link',
                condition: canGoToRetoure,
                process: "ViewRetoure"
            },
            {
                label: $scope.trns.cancelConditions,
                action: ctrl.cancelConditions,
                type: 'dialogaction',
                condition: canCancelConditions
            },
            {
                label: $scope.trns.cancelMasterConditions,
                action: ctrl.cancelMasterConditions,
                type: 'dialogaction',
                condition: canCancelMasterConditions
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canSave() {
        return !$scope.data.isClosed && !$scope.data.isSupplier && !$scope.data.forceCloseDeliveryComplaint && $scope.data.items.length;
    }

    function canSaveAndClose() {
        return !$scope.data.isClosed && !$scope.data.isSupplier && $scope.data.canClose && $scope.data.items.length;
    }

    function canDelete() {
        return $scope.data.id > 0 && !$scope.data.isSupplier && !$scope.data.isClosed;
    }

    function canAddItem() {
        return !$scope.data.isClosed && ($scope.data.deliveryNote.selected || ctrl.hidePopup()) && !$scope.data.isSupplier;
    }

    function canToggleComments() {
        return $scope.selectedComplaintItems.length > 0 || $scope.data.isClosed;
    }

    function canSendMessage() {
        return $scope.data.id > 0 && !$scope.data.isSupplier;
    }

    function getRetoureLink() {
        return "retoure/" + $scope.data.retoureId;
    }

    function canGoToRetoure() {
        return $scope.data.retoureId > 0 && $scope.data.isClosed && !$scope.data.isSupplier;
    }

    function canCancelConditions() {
        return $scope.data.allowConditionCancellation;
    }

    function canCancelMasterConditions() {
            return $scope.data.allowConditionMasterCancellation;
        }
}